import {getGlobleInfo} from '@/utils/request'
import store from '@/store/index.js'
import {isWeiXin} from '@/utils/validate.js'
import {getIP, getUserByCode, getWxSignatureReq} from '@/api/hwgk_api.js'
export const appId = import.meta.env.VITE_APP_APPID

export const getWxSignatureEvent = async (query) => {
  const formData = new FormData()
  formData.append('url', query.url)
  console.log('appId---->', appId)
  let a = await getWxSignatureReq(formData).then(res=>{
    if (res.code === 1) {
      return {
        rtnCode: '0000',
        rtnMsg: '成功',
        ...res.result
      }
    } else {
      return {
        rtnCode: '1111',
        rtnMsg: res.message,
        ...res.result
      }
    }
  })
  return a
}


const getWxOauthUrl = () => {
  console.log(location.href)
  let params = {
    appid: appId,
    redirect_uri: location.href,
    response_type: 'code',
    scope: 'snsapi_userinfo',
    state: 'STATE'
  }
  params = new URLSearchParams(params)
  return `https://open.weixin.qq.com/connect/oauth2/authorize?${params}#wechat_redirect`
}

export const getUserInfo = async (code, next) => {
  if (isWeiXin()) {
    if (code) {
      // 微信授权重定向回来
      const user = await getUserByCode({
        code
      }).then(res => {
        console.log('getUserByCode', JSON.stringify(res))
        return res
      })
      if (user.code===1) {
        const wxInfo = {}
        // 微信信息
        if (user.result&&user.result.result){
          wxInfo.openId = user.result.result.wxOpenid
          wxInfo.nickName = user.result.result.wxNickname
          wxInfo.headimgurl = user.result.result.wxHeaderUrl
          wxInfo.userId = user.result.result.userId
          //todo 存到vuex里面
          store.dispatch('userStore/setStateActions', {
            userId: wxInfo.userId,
            openId: wxInfo.openId,
            nickName: wxInfo.nickName,
            headimgurl: wxInfo.headimgurl
          })
        }
        next()
      } else {
        console.error('微信获取信息异常')
      }
    } else {
      location.href = getWxOauthUrl()
    }
  } else {
    const ip = await getIP().then(res => {
      if (res.code === 1) {
        return res.result
      } else {
        return 'unknow user'
      }
    })
    store.dispatch('userStore/setStateActions', {
      userId: ip,
      openId:'ip address',
      nickName:ip,
      headimgurl:''
    })
  }
}

export const getQueryJson = (key, url) => {
  url = location.href
  let params = {}
  url.replace(/([^#?&]+)=([^#?&/]+)/g, ($0, $1, $2) => {
    params[$1] = decodeURIComponent($2)
  })
  return key ? params[key] : params
}
export const isToShowPage = async (next) => {
  let paramObj = getQueryJson()
  console.log('isToShowPage', paramObj)
  await getUserInfo(paramObj.code, next)
  next()
}

export const clearSessionToken = () => {
  const user_temp = {
    token: '',
    openId: getGlobleInfo().userId,
    nickName: getGlobleInfo().nickName,
    headImgUrl: getGlobleInfo().headImgUrl
  }
  store.dispatch('userStore/changeUserInfo', {
    zkr_campaign_token: user_temp.token,
    zkr_campaign_userId: user_temp.openId,
    zkr_campaign_userInfo: user_temp
  })
  return user_temp
}

export const updateSessionToken = (token) => {
  const user_temp = {
    token: token,
    openId: getGlobleInfo().userId,
    nickName: getGlobleInfo().nickName,
    headImgUrl: getGlobleInfo().headImgUrl
  }
  store.dispatch('userStore/changeUserInfo', {
    zkr_campaign_token: user_temp.token,
    zkr_campaign_userId: user_temp.openId,
    zkr_campaign_userInfo: user_temp
  })
  return user_temp
}

